"use strict";
function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
var StaticFunc_1 = require("./StaticFunc");
__export(require("./ElmerWorker"));
__export(require("./EnumMessage"));
exports.objectToWorkerCodeFn = StaticFunc_1.objectToWorkerCode;
exports.objectToWorkerDataFn = StaticFunc_1.objectToWorkerData;
exports.workerDataToObjectFn = StaticFunc_1.workerDataToObject;
